
import React, { useState } from "react";
import {
  FaUserCircle,
  FaSignOutAlt,
  FaUser,
  FaChevronDown,
  FaBars
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import logoImg from "../../assets/images/nav-logo.png";

const UserNavbar = ({ userInfo, onMenuClick }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();

  const storedUserStr = localStorage.getItem("user");
  const storedUser = storedUserStr ? JSON.parse(storedUserStr) : null;

  const userName =
    localStorage.getItem("userName") ||
    storedUser?.name ||
    "User";

  const userEmail =
    storedUser?.emailid ||
    storedUser?.email ||
    "";

  const handleLogout = () => {
    localStorage.clear();
    navigate("/TGSH/login");
  };

  const handleProfileClick = () => {
    setShowDropdown(false);
    navigate("/TGSH/user/profile");
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-[9999] flex items-center justify-between px-3 md:px-6"
      style={{
        backgroundColor: "#64a106",
        height: "64px",
      }}
    >
      {/* Left */}
      <div className="flex items-center gap-2 flex-shrink-0">

        <button
            className="md:hidden text-white text-xl"
            onClick={onMenuClick}
        >
            <FaBars />
        </button>
        <div className="w-10 h-10 bg-white rounded-full overflow-hidden flex items-center justify-center">
          <img
            src={logoImg}
            alt="TGSH Logo"
            className="w-full h-full object-contain"
          />
        </div>

        
      
        <div className="flex flex-col">
            <span className="text-white font-bold text-[12px] uppercase leading-tight">
                USER
            </span>
            <span className="text-white font-bold text-[12px] uppercase leading-tight">
                PANEL
            </span>
        </div>

        <h1 className="hidden md:block text-white font-bold text-[13px] uppercase tracking-wider ml-8">
            THE GLOBAL SCHOOL OF HAPPINESS
        </h1>

      </div>

      

      {/* Right */}
      <div className="relative flex items-center">
        <button
          onClick={() => setShowDropdown(!showDropdown)}
          className="flex items-center gap-2 text-white bg-transparent border-none cursor-pointer"
        >
          <div className="hidden lg:block text-right">
            <div className="text-[11px] font-bold uppercase">
              {userName}
            </div>
            <div className="text-[10px] opacity-80">
              {userEmail}
            </div>
          </div>

          <FaUserCircle size={22} />
          <FaChevronDown
            className={`transition-transform ${
              showDropdown ? "rotate-180" : ""
            }`}
          />
        </button>

        {showDropdown && (
          <div className="absolute right-0 top-[64px] w-52 bg-white rounded-lg shadow-xl border z-[99999]">
            <div className="px-4 py-3 border-b">
              <p className="font-semibold text-sm mb-0">
                Hello, {userName}
              </p>
            </div>

            <button
              onClick={handleProfileClick}
              className="w-full flex items-center gap-3 px-4 py-3 hover:bg-gray-100 text-left"
            >
              <FaUser />
              View Profile
            </button>

            <button
              onClick={handleLogout}
              className="w-full flex items-center gap-3 px-4 py-3 hover:bg-red-50 text-red-600 text-left"
            >
              <FaSignOutAlt />
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default UserNavbar;
